module.exports = __webpack_public_path__ + "img/error_icon.c52fc479.svg";